<div class="account-settings-layout py-4 px-3 px-md-4 px-xl-5">
  <div class="account-settings-layout__shell">
    <aside class="d-none d-lg-block account-settings-layout__nav-col">
      <div class="account-settings-layout__nav-sticky">
        <app-account-settings-nav></app-account-settings-nav>
      </div>
    </aside>

    <main class="account-settings-layout__content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
